import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@/modules/common/components/Dialog';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import { withFetch } from '~/hocs/fetch';
import Table from './Table';

let abortController;

const DialogView = (props) => {
    const [lead, setLead] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetch = () => {
        setLoading(true);
        props.fetch.get(`/api/leads/${props.selectedLead.id}/`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setLead(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    useEffect(() => {
        if (props.open) {
            abortController = new AbortController();
            fetch();
        }
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, [props.open]);

    const handleClose = () => {
        props.setOpen(false);
        props.setSelectedLead(null);
    };

    const handleExited = () => {
        setLead(null);
    };

    return (
        <Dialog id="leads-dialog-view" title="Просмотр лида" open={props.open} onClose={handleClose}
                onExited={handleExited}
        >
            {(!loading)
                ? <>
                    {(lead)
                        ? <Table lead={lead}/>
                        : <ErrorFetch onClick={() => fetch()}/>
                    }
                </>
                : <Spinner/>
            }
        </Dialog>
    );
};

DialogView.propTypes = {
    selectedLead: PropTypes.object,
    setSelectedLead: PropTypes.func,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
};

let Component = DialogView;
Component = withFetch(Component);

export default Component;
